export interface IVideoConferenceOptions {
    mic?: boolean;
    cam?: boolean;
}
